import React, { useContext, useState } from "react";
import "../../../assests/css/teachers/TeacherHelpSupport.css";
import {
  FaQuestionCircle,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import TeacherMasterLayout from "../../../layouts/TeacherMasterLayout";
import Swal from "sweetalert2";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";

const TeacherHelpSupport = () => {

  const { baseUrl } = useContext(AppContext);

  // States
  const location = useLocation();
  const navigate = useNavigate();

  const requestType = location.state?.request_type || "support";
  const referenceId = location.state?.reference_id || null;
  const issueType = location.state?.issue_type || "";
  const adminId = location.state?.admin_id || null;
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [selectissue, setSelectIssue] = useState("");
  const [describeissue, setDescribeIssue] = useState("");

  // Add Support Request
  const addSupportRequest = () => {

    const formData = new FormData();
    const teacher = JSON.parse(localStorage.getItem("teacher"));
    formData.append("ngteacher_id", teacher.id);
    formData.append("ngadmin_id", adminId);
    formData.append("request_type", requestType);
    formData.append("reference_id", referenceId);
    formData.append("selectissue", selectissue);
    formData.append("describeissue", describeissue);
    formData.append("status", "Pending");
    // formData.append("ngteacher_id", 1)
    // formData.append("name", name);
    // formData.append("email", email);
    formData.append("selectissue", selectissue);
    formData.append("describeissue", describeissue);

    axios
      .post(
        `${baseUrl}/teacher/helpsupport/addHelpSupport`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )

      .then((response) => {

        console.log(response.data);

        // setName("");
        // setEmail("");
        setSelectIssue("");
        setDescribeIssue("");

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Support Request Submitted Successfully",
          confirmButtonColor: "#6A88CE",
        }).then(() => {
          navigate("/teacher/myrequest");
        });

      })

      
      .catch((error) => {

        console.log(error);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong!",
        });

      });

  };

  return (
    <TeacherMasterLayout>

      {/* Topbar */}
      <header className="tgp-topbar">
        <h3>Welcome, Teacher 👋</h3>
        <div className="tgp-profile">👤</div>
      </header>

      <div className="ths-container">

        <h2 className="ths-title">
          Help & Support
        </h2>

        <p className="ths-subtitle">
          Need help? We’re here to support you.
        </p>

        {/* Support Cards */}
        <div className="ths-card-wrapper">

          <div className="ths-card">
            <FaQuestionCircle className="ths-icon" />

            <h4>FAQs</h4>

            <p>
              Find answers to common teacher panel questions.
            </p>
          </div>

          <div className="ths-card">
            <FaEnvelope className="ths-icon" />

            {/* <h4>Email Support</h4> */}

            <p>support@schoolpanel.com</p>
          </div>

          <div className="ths-card">
            <FaPhoneAlt className="ths-icon" />

            <h4>Call Support</h4>

            <p>+92 300 1234567</p>
          </div>

        </div>

        {/* Contact Form */}
        <div className="ths-form-section">

          <h3>Contact Support</h3>

          <form className="ths-form">

            {/* <input
              type="text"
              placeholder="Your Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            /> */}

            {/* <input
              type="email"
              placeholder="Your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            /> */}

            <select
              value={selectissue}
              onChange={(e) => setSelectIssue(e.target.value)}
            >

              <option value="">
                Select Issue Type
              </option>

              <option value="Technical Issue">
                Technical Issue
              </option>

              <option value="Account Issue">
                Account Issue
              </option>

              <option value="Attendance Issue">
                Attendance Issue
              </option>

              <option value="Exam / Result Issue">
                Exam / Result Issue
              </option>

            </select>

            <textarea
              placeholder="Describe your issue..."
              value={describeissue}
              onChange={(e) => setDescribeIssue(e.target.value)}
            />

            <button
              type="button"
              onClick={addSupportRequest}
            >
              Submit Request
            </button>

          </form>

        </div>

      </div>

    </TeacherMasterLayout>
  );
};

export default TeacherHelpSupport;